<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow v-if="!loading" class="justify-content-center">
      <CRow v-if="data.message === 'Activation Success'">
        {{ data.message }}
        <br>
        Welcome to IFGF
        <br>
        Your account is successfully verified. Please login to access your account.
      </CRow>
      <CRow v-else>
          {{ data.message }}
      </CRow>
    </CRow>
    <CRow v-else class="justify-content-center">
      <b-spinner variant="primary" label="Spinning"><br></b-spinner>
    </CRow>

  </CContainer>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import axios from 'axios';

import user from '@/services/user'

export default {
  

    data(){
        return{
            data: {
              message: ''
            },
            loading: true,
        }
    },
    created() {
      this.loadData()
    },
    computed: {

    },
    methods: {
      loadData(){
        user.activation(this.$route.query.id)
        .then(res => {
          this.data.message = res.message
          this.loading = false
          //this.data.id = res.data.iduser
        })  
      },   
    }
}
</script>
